<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box">
          <div class="box-header with-border">
            <h3 class="box-title">Cases</h3>
          </div>
          <!-- /.box-header -->
          <div class="box-body">

            <div class="row">
              <div class="col-sm-5">
                <div class="row vertical-align-center">
                  <div class="dataTables_length col-sm-4" id="example1_length">
                    <label>Show
                      <select v-on:change="showSizeChange" name="example1_length" aria-controls="example1" class="form-control input-sm">
                        <!--<option value="2">2</option>-->
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select> entries
                    </label>
                  </div>
                  <button type="button" v-on:click="openModal()" class="btn btn-primary new-btn col-sm-offset-1 col-sm-2">New case</button>
                </div>
              </div>

              <div class="col-sm-6">
                <div id="example1_filter" class="dataTables_filter">
                  <input type="search" class="form-control input-sm" v-model="query" v-on:change="searchChange" placeholder="Syria" aria-controls="example1">
                  <button type="submit" class="btn btn-flat btn-primary search-btn" v-on:click="search">
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="row filters-row">
              <div class="col-sm-12 filters">
                <div class="card card-body">
                  <tags-search ref="tags-search"></tags-search>
                </div>
              </div>
            </div>

            <div class="row">
                <div class="col-sm-12 table-responsive">

                  <table role="grid" class="table table-bordered table-striped dataTable">
                    <thead>
                      <tr role="row">
                        <th v-on:click="sortBy('creationDate','true')" v-bind:class="{ active: sortField === 'creationDate' }" aria-label="Rendering engine: activate to sort column descending" aria-sort="ascending" colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="sorting_asc">Creation Date</th>
                        <th aria-label="Browser: activate to sort column ascending" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">Name</th>
                        <th aria-label="Platform(s): activate to sort column ascending" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">Status</th>
                        <th v-on:click="sortBy('testimonySize','true')" v-bind:class="{ active: sortField === 'testimonySize' }" aria-label="Engine version: activate to sort column ascending" colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="sorting_asc">Testimonies size</th>
                        <th aria-label="CSS grade: activate to sort column ascending" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">Creator</th>
                        <th aria-label="Tags" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">Tags</th>
                      </tr>
                    </thead>
                    <div v-if="cases.length === 0" class="no-data">No data found</div>
                    <tbody v-else>
                      <tr class="even clickable" role="row" v-for="currentCase in cases" v-on:click="goToCase(currentCase)">
                        <td class="sorting_1">{{currentCase.creationDate | prettyDateTime}}</td>
                        <td>{{currentCase.name}}</td>
                        <td>{{currentCase.status}}</td>
                        <td>{{currentCase.testimonySize}}</td>
                        <td>{{currentCase.creatorName}}</td>
                        <td>
                          <span v-for="tag in tagsByCase[currentCase._id]" class="label label-default" v-on:click.stop="searchByTag(tag)">{{tag}}</span>
                        </td>
                      </tr>
                    </tbody>
                    <!-- <tfoot>
                      <tr>
                        <th colspan="1" rowspan="1">Creation Date</th>
                        <th colspan="1" rowspan="1">Name</th>
                        <th colspan="1" rowspan="1">Status</th>
                        <th colspan="1" rowspan="1">Testimonies size</th>
                        <th colspan="1" rowspan="1">Creator</th>
                      </tr>
                    </tfoot> -->
                  </table>
                </div>
              </div>

              <div class="row" v-if="cases.length > 0">
                <div class="align-infos col-sm-12">
                  <div class="dataTables_info" id="example1_info" role="status" aria-live="polite">Showing {{total - cases.length + 1 > (page + 1) * size - 1 ? (page + 1) * size - 1 : total - cases.length + 1}} to {{total > (page + 1) * size ? (page + 1) * size:total}} of {{total}} entries</div>
                </div>
                <div class="table-pagination col-sm-12">
                  <paginate
                    :page-count="pageTotal"
                    :page-range="3"
                    :margin-pages="2"
                    :click-handler="changePage"
                    :prev-text="'Prev'"
                    :force-page="page"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'">
                  </paginate>
                </div>
                
              </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
    <new-case-modal @create="createCase" id="NewCaseModal"></new-case-modal>
  </section>
</template>

<script>
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'
import Multiselect from 'vue-multiselect'
import api from '../../api'

export default {
  name: 'Cases',
  components: { Multiselect },
  data () {
    return {
      cases: [],
      tagsByCase: {},
      query: null,
      size: 10,
      pageTotal: 0,
      total: 0,
      page: 0,
      sortField: 'creationDate',
      desc: 'true'
    }
  },
  methods: {
    openModal () {
      window.jQuery('#NewCaseModal').modal({})
    },
    createCase (name) {
      console.log(`create case with name : ${name}`)
      api.authenticatedRequest('post', '/cases', { name: name })
      .then(response => {
        this.refresh(true)
      })
      .catch(error => {
        console.log(error)
        if (error.response.status === 401) { // InvalidCredentialsError
          this.response = 'Username/Password incorrect. Please try again.'
          return
        }
        this.response = 'Server appears to be offline'
      })
    },
    goToCase (selectedCase) {
      const id = selectedCase._id ? selectedCase._id : selectedCase.id // TODO because of search result (ES expects an id field named 'id'). TO REFACTO
      this.$router.push({name: 'Case', params: { id: id }})
    },
    sortBy (sortField, desc) {
      this.sortField = sortField
      this.desc = desc
      this.refresh(true)
    },
    changePage (pageNum) {
      this.page = pageNum - 1
      this.refresh()
    },
    showSizeChange (e) {
      this.size = e.target.value
      this.refresh(true)
    },
    refresh (toFirstPage = false) {
      if (toFirstPage) {
        this.page = 0
      }

      this.getTagsGroupedByCase()
      if (this.$route.query.tag) {
        this.searchByTag(this.$route.query.tag)
      } else if (this.query === null || this.query === '') {
        this.getCases()
      } else {
        this.search(false)
      }
    },
    searchChange (e) {
      this.refresh(true)
    },
    searchByTag (tagName) {
      this.$refs['tags-search'].selected = [{name: tagName}]
      let endpoint = `/cases/search?q=*&size=${this.size}&page=0&sortField=${this.sortField}&desc=${this.desc}&tag=${tagName}`

      api.authenticatedRequest('get', endpoint)
        .then(response => {
          const data = response.data
          this.cases = data.data
          this.total = data.total
          this.pageTotal = Math.ceil(this.total / this.size)
        })
        .catch(error => {
          console.log(error)
          if (error.response.status === 401) { // InvalidCredentialsError
            this.response = 'Username/Password incorrect. Please try again.'
            return
          }
          this.response = 'Server appears to be offline'
        })
    },
    search (isNewSearch = true) {
      if (isNewSearch) {
        this.page = 0
      }
      let endpoint = `/cases/search?q=${this.query === null || this.query === '' ? '*' : this.query}&size=${this.size}&page=${this.page}&sortField=${this.sortField}&desc=${this.desc}`
      this.$refs['tags-search'].selected.forEach(tag => {
        endpoint += `&tag=${tag.name}`
      })

      api.authenticatedRequest('get', endpoint)
      .then(response => {
        const data = response.data
        this.cases = data.data
        this.total = data.total
        this.pageTotal = Math.ceil(this.total / this.size)
      })
      .catch(error => {
        console.log(error)
        if (error.response.status === 401) { // InvalidCredentialsError
          this.response = 'Username/Password incorrect. Please try again.'
          return
        }
        this.response = 'Server appears to be offline'
      })
    },
    getCases () {
      /* Making API call to authenticate a user */
      api.authenticatedRequest('get', `/cases?size=${this.size}&page=${this.page}&sortField=${this.sortField}&desc=${this.desc}`)
      .then(response => {
        const data = response.data
        this.cases = data.data
        this.total = data.total
        this.pageTotal = Math.ceil(this.total / this.size)
      })
      .catch(error => {
        console.log(error)
        if (error.response.status === 401) { // InvalidCredentialsError
          this.response = 'Username/Password incorrect. Please try again.'
          return
        }
        this.response = 'Server appears to be offline'
      })
    },
    getTagsGroupedByCase () {
      api.authenticatedRequest('get', '/tags?groupBy=caseId')
        .then(response => {
          response.data.forEach(item => {
            this.tagsByCase[item.occurrenceId] = item.tags
          })
        })
        .catch(error => {
          console.log(error)
          if (error.response.status === 401) { // InvalidCredentialsError
            this.response = 'Username/Password incorrect. Please try again.'
            return
          }
          this.response = 'Server appears to be offline'
        })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.refresh()
    })
  }
}
</script>
<style>
/* Using the bootstrap style, but overriding the font to not draw in
   the Glyphicons Halflings font as an additional requirement for sorting icons.

   An alternative to the solution active below is to use the jquery style
   which uses images, but the color on the images does not match adminlte.

@import url('/static/js/plugins/datatables/jquery.dataTables.min.css');
*/

@import url('/static/js/plugins/datatables/dataTables.bootstrap.css');

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'Font Awesome 5 Free';
}

.clickable {
    cursor: pointer;
}

table.dataTable thead .active:after {
    opacity: 0.5!important;
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
  opacity: 0.2;
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
  opacity: 0.2;
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
  opacity: 0.2;
}

.vertical-align-center {
  display: flex;
  align-items: center;
}

.new-btn {
  justify-content: center !important;
  margin: auto !important;
}

.search-btn:active:focus,
.new-btn:active:focus {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// Cases.vue?320c876a